<template>
  <Breadcrumbs title="Participantes" main="Administración" />
  <div class="container-fluid">
    <div class="user-profile">
      <div class="row">
        <TopMenu
          :searchText="searchText"
          :showtab="showtab"
          @changetab="changetab"
        />
        <div class="col-12 mb-3">
          <SearchInput
            v-model="searchText"
            placeholder="Buscar por nombre..."
          />
        </div>
        <div v-if="showtab === 'app-user'">
          <TablaParticipantes
            :users="filteredParticipants"
            @change-status="changeStatusParticipant"
          />
        </div>
        <div v-if="showtab === 'app-solicitantes'">
          <TablaSolicitantes
            :users="filteredSolicitantes"
            @change-status="changeStatusSolicitante"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import TopMenu from "./TopMenu.vue";
import TablaParticipantes from "./TableParticipants.vue";
import TablaSolicitantes from "./TableSolicitantes.vue";
import SearchInput from "@/components/SearchInput.vue";
import axios from "@/includes/connection";
import { ref, computed, onMounted } from "vue";
import { toast } from "vue3-toastify";

const searchText = ref("");
const showtab = ref("app-user");
const participantes = ref([]);
const solicitantes = ref([]);

onMounted(() => {
  fetchParticipants();
  fetchSolicitantes();
});

const fetchParticipants = () => {
  axios.get("/clie/users/all").then((res) => {
    participantes.value = res.data;
  });
};

const fetchSolicitantes = () => {
  axios.get("/user").then((res) => {
    solicitantes.value = res.data;
  });
};

const filteredParticipants = computed(() => {
  return participantes.value.filter((user) =>
    user.name_complete.toLowerCase().includes(searchText.value.toLowerCase())
  );
});

const filteredSolicitantes = computed(() => {
  return solicitantes.value.filter((user) =>
    `${user.name} ${user.first_last_name} ${user.second_last_name}`
      .toLowerCase()
      .includes(searchText.value.toLowerCase())
  );
});

const changetab = (tab) => {
  showtab.value = tab;
  searchText.value = "";
};

const changeStatusParticipant = (id) => {
  const userId = parseInt(localStorage.getItem("userId"));
  axios
    .patch(`/clie/changeStatus/${id}`, { user_id: userId })
    .then(() => {
      toast.success("Estado del participante actualizado");
      fetchParticipants();
    })
    .catch(() => {
      toast.error("Error al cambiar el estado del participante");
      fetchParticipants();
    });
};

const changeStatusSolicitante = (id) => {
  const userId = parseInt(localStorage.getItem("userId"));
  axios
    .patch(`/user/changeStatus/${id}`, { user_id: userId })
    .then(() => {
      toast.success("Estado del solicitante actualizado");
      fetchSolicitantes();
    })
    .catch((error) => {
      console.log(error);
      toast.error("Error al cambiar el estado del solicitante");
      fetchSolicitantes();
    });
};
</script>
